import { PERMISSION_DENIED } from "../../constants/strings";
import * as auth from "../../services/auth";
import api from "../../services/api";

export const SET_USER_DATA = "SET_USER_DATA";
export const SET_USER_META_DATA = "SET_USER_META_DATA";

export const setUserData = (user) => ({
  type: SET_USER_DATA,
  payload: user,
});

export const setUserMetaData = (data) => ({
  type: SET_USER_META_DATA,
  payload: data,
});

export const login = () => async (dispatch) => {
  try {
    const loggedIn = await auth.login();
    if (!loggedIn) dispatch(setUserData({ error: PERMISSION_DENIED }));
  } catch (e) {}
};

export const onUserAuth = (user) => async (dispatch) => {
  if (user) {
    dispatch(
      setUserData({
        email: user.email,
        name: user.displayName,
        uid: user.uid,
        photoURL: user.photoURL,
      })
    );
    await dispatch(fetchUserMetadata(user.uid));
  }
};

export const logout = () => async (dispatch) => {
  try {
    await auth.logout();
    dispatch(setUserData(null));
  } catch (e) {}
};

export const fetchUserMetadata = (id) => async (dispatch) => {
  const {
    data: { user },
  } = await api.get(`/user/${id}`);
  dispatch(setUserMetaData(user));
};
